import { ImageType, ShapeType } from '@/shared/api/BaseAPI.model'

type TableModel = {
  id: string
  number: number
  qrCodeImage: {
    url: string
    version: string
  }
  qrCodeCardId?: string
}

type tablesResponseModel = TableModel[]

type qrCodeCardModel = {
  id: string
  title: string
  description: string
  shape: ShapeType
  alignment?: 'left' | 'center'
  withNfc: boolean
  languageCode: 'en' | 'pl'
  contentColor: string
  contrastColor: string
  backgroundColor: string
  width?: number
  height?: number
  tableIds: string[]
  diameter?: number
  backgroundImage?: ImageType
}

type qrCodeCardsResponseModel = qrCodeCardModel[]

type qrCodeCardsPostPayloadModel = Omit<
  qrCodeCardModel,
  'id' | 'backgroundImage'
> & {
  backgroundImage?: File | null
}

type qrCodeCardsPutPayloadModel = Omit<qrCodeCardModel, 'backgroundImage'> & {
  backgroundImage?: File | null
}

enum QUERY {
  TABLES = 'tables',
  QR_CODE_CARDS = 'qrCodeCards'
}

export { QUERY }

export type {
  tablesResponseModel,
  qrCodeCardsResponseModel,
  qrCodeCardModel,
  qrCodeCardsPostPayloadModel,
  qrCodeCardsPutPayloadModel,
  TableModel
}
